var map = {
	"./CHANGELOG_2017.md": 73039,
	"./CHANGELOG_2018.md": 14050,
	"./CHANGELOG_2019.md": 56351,
	"./CHANGELOG_2020.md": 89147,
	"./CHANGELOG_2021.md": 32602,
	"./CHANGELOG_2022.md": 76990,
	"./CHANGELOG_2023.md": 84702,
	"./CHANGELOG_2024.md": 29674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79954;